import React from 'react';
import "./MantraHeading.css";

function MantraHeading(props) {
  return (
    <div data-aos="zoom-in" data-aos-delay={400} className="mantra-container screen-container" id={props.id || ""}>
      <div style={{display : "flex", width : "100%"}}>
          <span className="icon-head">&#21328;</span>
          <marquee className="marq">ॐ भूर्भुवः स्व: तत्सवितुर्वरेण्यं भर्गो देवस्य धीमहि धियो यो नः प्रचोदयात् ॥  ॐ भूर्भुवः स्व: तत्सवितुर्वरेण्यं भर्गो देवस्य धीमहि धियो यो नः प्रचोदयात् ॥   ॐ भूर्भुवः स्व: तत्सवितुर्वरेण्यं भर्गो देवस्य धीमहि धियो यो नः प्रचोदयात् ॥   ॐ भूर्भुवः स्व: तत्सवितुर्वरेण्यं भर्गो देवस्य धीमहि धियो यो नः प्रचोदयात् ॥   ॐ भूर्भुवः स्व: तत्सवितुर्वरेण्यं भर्गो देवस्य धीमहि धियो यो नः प्रचोदयात् ॥ </marquee>
          <span className="icon-head">&#21328;</span>
        </div>
    </div>
  )
}

export default MantraHeading